// Path: //src/components/TimerBar.tsx
// Created to render a 300-second timer bar with 100-second intervals ("Charge In", "Expand Out", "Be In")
// Includes green border vibration when session is active
// 05/26/25 12:31 PM +07
// Path: src/components/TimerBar.tsx
// Created to render a 300-second timer bar with 100-second intervals ("Charge In", "Expand Out", "Be In")
// Includes green border vibration when session is active
// 05/26/25 12:31 PM +07
// Path: src/components/TimerBar.tsx
// Fixed styled-components prop forwarding by using transient props ($isSessionActive, $progress)
// 05/31/25 04:59 PM +07
// Path: src/components/TimerBar.tsx
// Added remaining time and percentage display for the 300-second timer
// Improved styling for better visibility
// 05/31/25 05:58 PM +07
// Path: src/components/TimerBar.tsx
// Updated to shorten "seconds" to "s" and "remaining" to "re"
// Ensured progress is an integer by relying on TimerContext fix
// 05/31/25 06:53 PM +07
import React from "react";
import styled, { keyframes } from "styled-components";

interface TimerBarProps {
  progress: number; // Progress in seconds (0–300)
  intervalLabel: string; // "Charge In", "Expand Out", "Be In"
  isSessionActive: boolean;
}

// Keyframes for green border vibration
const vibrate = keyframes`
  0% { box-shadow: 0 0 5px #00ff00; }
  50% { box-shadow: 0 0 10px #00ff00, 0 0 20px #00ff00; }
  100% { box-shadow: 0 0 5px #00ff00; }
`;

const TimerContainer = styled.div<{ $isSessionActive: boolean }>`
  width: 100%;
  max-width: 300px;
  margin: 10px auto;
  padding: 10px;
  background: #333;
  border-radius: 10px;
  text-align: center;
  display: ${props => (props.$isSessionActive ? "block" : "none")};
  animation: ${props => props.$isSessionActive ? vibrate : "none"} 1s infinite;
`;

const ProgressBar = styled.div<{ $progress: number }>`
  width: ${props => (props.$progress / 300) * 100}%;
  height: 20px;
  background: #00ff00;
  border-radius: 10px;
  transition: width 1s linear;
`;

const Label = styled.p`
  color: #fff;
  font-size: 16px;
  margin: 5px 0;
`;

const ProgressInfo = styled.p`
  color: #fff;
  font-size: 14px;
  margin: 5px 0;
`;

const TimerBar: React.FC<TimerBarProps> = ({ progress, intervalLabel, isSessionActive }) => {
  const remainingSeconds = 300 - progress;
  const percentage = Math.round((progress / 300) * 100);

  return (
    <TimerContainer $isSessionActive={isSessionActive}>
      <Label>olsme in progress: {intervalLabel}</Label>
      <ProgressBar $progress={progress} />
      <ProgressInfo>
        {remainingSeconds} s re ({percentage}%) {/* Shortened "seconds" to "s", "remaining" to "re" */}
      </ProgressInfo>
    </TimerContainer>
  );
};

export default TimerBar;